import type { ReactElement } from "react";
import dynamic from "next/dynamic";
import AppLayout from "components/app/layout/app-layout";
import CompanyPage from "components/company/company-page-layout/company-page";
import type { CompanyPageProps } from "components/company/company-page-layout/company-page";

const CompanyOverview = dynamic(
  () => import("components/company/company-overview/company-overview"),
  { ssr: false }
);

export {
  getStaticPaths,
  getStaticProps,
} from "components/company/company-page-layout/company-page";

const CompanyOverviewPage = (props: CompanyPageProps) => (
  <CompanyPage {...props}>
    <CompanyOverview companySlug="" isInternational={false} tags={[]} />
  </CompanyPage>
);

CompanyOverviewPage.getLayout = (page: ReactElement) => (
  <AppLayout>{page}</AppLayout>
);

export default CompanyOverviewPage;
